import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "order-reimburse-content"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
import { Empty } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDrawer',
  props: {
    modalVisible: {
      type: Boolean
    },
    orderInfo: null
  },
  emits: ['update:modalVisible'],
  setup(__props, {
    emit
  }) {
    const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
    const activeKey = ref([1, 2]);
    const handleCancel = () => {
      emit('update:modalVisible', false);
    };
    // 新增的格式化 JSON 方法
    const formatJson = jsonString => {
      try {
        const jsonObject = JSON.parse(jsonString);
        return `<pre>${JSON.stringify(jsonObject, null, 2)}</pre>`; // 格式化为可读的 JSON
      } catch (e) {
        return jsonString; // 如果解析失败，返回原始字符串
      }
    };
    return (_ctx, _cache) => {
      const _component_a_collapse_panel = _resolveComponent("a-collapse-panel");
      const _component_a_collapse = _resolveComponent("a-collapse");
      const _component_a_drawer = _resolveComponent("a-drawer");
      return _openBlock(), _createBlock(_component_a_drawer, {
        open: __props.modalVisible,
        placement: "right",
        title: "查看详情",
        width: "600px",
        onClose: handleCancel
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_collapse, {
          activeKey: activeKey.value,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => activeKey.value = $event)
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_component_a_collapse_panel, {
            key: 1,
            header: "请求体"
          }, {
            default: _withCtx(() => [__props.orderInfo.responseBody ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: "text",
              innerHTML: formatJson(__props.orderInfo.requestBody)
            }, null, 8, _hoisted_2)) : (_openBlock(), _createBlock(_unref(Empty), {
              key: 1,
              image: _unref(simpleImage)
            }, null, 8, ["image"]))]),
            _: 1
          })), (_openBlock(), _createBlock(_component_a_collapse_panel, {
            key: 2,
            header: "响应数据"
          }, {
            default: _withCtx(() => [__props.orderInfo.responseBody ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: "text",
              innerHTML: formatJson(__props.orderInfo.responseBody)
            }, null, 8, _hoisted_3)) : (_openBlock(), _createBlock(_unref(Empty), {
              key: 1,
              image: _unref(simpleImage)
            }, null, 8, ["image"]))]),
            _: 1
          }))]),
          _: 1
        }, 8, ["activeKey"])])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});